// extracted by mini-css-extract-plugin
export default {"input":"CustomerNameInput_input__X5U4f"};